<script setup lang="ts">
import type { FooterMultiLink } from '@optionway/models';

defineProps<{
  multiLink: FooterMultiLink;
}>();
</script>
<template>
  <div class="text-sm font-normal">
    <template
      v-for="(item, index) in multiLink.items"
      :key="index"
    >
      <button
        v-if="item.type === 'link' && item.action"
        type="button"
        class="inline-flex cursor-pointer items-center gap-2 text-left hover:text-text-accent-700"
        @click="item.action()"
      >
        {{ $t(item.label) }}
        <component
          :is="resolveLucideIcon(item.icon)"
          v-if="item.icon"
          class="size-4 shrink-0 text-text-secondary-600"
          aria-hidden="true"
        />
      </button>
      <NuxtLinkLocale
        v-else-if="item.type === 'link' && item.localeAware"
        :to="item.to"
        :target="item.target"
        :title="item.title"
        class="inline-flex cursor-pointer items-center gap-2 hover:text-text-accent-700"
      >
        {{ $t(item.label) }}
        <component
          :is="resolveLucideIcon(item.icon)"
          v-if="item.icon"
          class="size-4 shrink-0 text-text-secondary-600"
          aria-hidden="true"
        />
      </NuxtLinkLocale>
      <NuxtLink
        v-else-if="item.type === 'link'"
        :to="item.to"
        :target="item.target"
        :title="item.title"
        class="inline-flex cursor-pointer items-center gap-2 hover:text-text-accent-700"
      >
        {{ $t(item.label) }}
        <component
          :is="resolveLucideIcon(item.icon)"
          v-if="item.icon"
          class="size-4 shrink-0 text-text-secondary-600"
          aria-hidden="true"
        />
      </NuxtLink>
      <span v-else>{{ ` ${$t(item.text)} ` }}</span>
    </template>
  </div>
</template>
